import type { RootState } from "@/app/store";
import { RelatorioAM } from "@/contexts/fiscalizacao/relatorioAM/model/RelatorioAM";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RelatorioAMState {
  items: RelatorioAM[];
}

const initialState: RelatorioAMState = {
  items: [],
};

const relatorioAMSlice = createSlice({
  name: "RELATORIO_AM",
  initialState,
  reducers: {
    add: {
      reducer: (state, action: PayloadAction<{ item: RelatorioAM }>) => {
        const { item } = action.payload;
        state.items.push({ ...item, offlineId: item.offlineId || Date.now() });
      },
      prepare: (item: RelatorioAM) => ({
        payload: { item },
      }),
    },
    remove: {
      reducer: (state, action: PayloadAction<{ offlineId: number }>) => {
        state.items = state.items.filter(
          (item) => item.offlineId !== action.payload.offlineId
        );
      },
      prepare: (offlineId: number) => ({
        payload: { offlineId },
      }),
    },
    update: {
      reducer: (state, action: PayloadAction<{ item: RelatorioAM }>) => {
        const index = state.items.findIndex(
          (item) => item.offlineId === action.payload.item.offlineId
        );
        state.items[index] = action.payload.item;
      },
      prepare: (item: RelatorioAM) => ({
        payload: { item },
      }),
    },
  },
});

export const relatorioAMAction = relatorioAMSlice.actions;

export default relatorioAMSlice.reducer;

export const getRelatoriosAM = (state: RootState) => {
  const listaInvertida = state.relatorioAM.items.map((_, ind, lista) => {
    return lista[lista.length - ind - 1];
  });

  return listaInvertida;
};
